"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _coreMatchMedia = _interopRequireDefault(require("@legacy-vfuk/core-match-media"));

var _coreBaseProps = require("@legacy-vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/Image.style"));

var _getBreakpointFallback = _interopRequireDefault(require("./helpers/getBreakpointFallback"));

var _getFallbackImage = _interopRequireDefault(require("./helpers/getFallbackImage"));

var _getSource = _interopRequireDefault(require("./helpers/getSource"));

var _breakpoints = require("./utils/breakpoints");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Image = function Image(props) {
  var componentName = 'Image';
  var theme = (0, _styledComponents.useTheme)();
  var fallbackImageObj = (0, _getFallbackImage["default"])(props);
  return /*#__PURE__*/_react["default"].createElement("picture", _extends({}, props.dataAttributes, {
    "data-selector": (0, _coreBaseProps.getDataSelector)(props.dataSelectorPrefix),
    id: props.id,
    "data-component-name": componentName,
    onLoad: props.onLoad,
    onError: props.onError
  }), _breakpoints.breakpoints.map(function (breakpoint, index) {
    var srcSet = (0, _getSource["default"])(breakpoint, props);
    if (!srcSet) return;
    return /*#__PURE__*/_react["default"].createElement("source", {
      media: "(min-width: ".concat(theme.breakpoints[breakpoint], "px)"),
      srcSet: srcSet,
      key: index
    });
  }), fallbackImageObj && _breakpoints.breakpoints.map(function (breakpoint, index) {
    return /*#__PURE__*/_react["default"].createElement(_coreMatchMedia["default"], {
      key: index,
      breakpoint: breakpoint
    }, /*#__PURE__*/_react["default"].createElement(Styled.Image, _extends({
      roundedCorners: props.roundedCorners,
      aspectRatio: props.aspectRatio,
      objectFit: props.objectFit,
      title: props.title,
      alt: props.alt
    }, (0, _getBreakpointFallback["default"])(breakpoint, props), {
      "data-selector": (0, _coreBaseProps.getDataSelector)(props.dataSelectorPrefix, 'image')
    })));
  }));
};

Image.displayName = "Image";
var _default = Image;
exports["default"] = _default;
//# sourceMappingURL=Image.js.map